import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { AgingReportScreen } from '@/features/inventory-analysis/aging-screen'
import {
  type InventoryReportSearch,
  inventoryReportSearchFrom,
} from '@/features/inventory-analysis/api'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/inventory/reports/aging')({
  validateSearch: (search: Record<string, unknown>): InventoryReportSearch =>
    inventoryReportSearchFrom(search),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'inventory_report.view'))
      throw redirect({ to: '/inventory' })
  },
  component: AgingReportRoute,
})

function AgingReportRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()

  return (
    <AgingReportScreen
      search={search}
      onSearchChange={(next) => void navigate({ to: '/inventory/reports/aging', search: next })}
    />
  )
}
